<template>
  <div>
    <page-title-bar></page-title-bar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-container fluid grid-list-xl pt-0>
      <v-layout row wrap justify-center>
        <v-flex xs12 md11>
          <app-card pt-0>
            <v-card-title>
              <h4>SỔ THEO DÕI THAY ĐỔI THÔNG TIN PHÒNG</h4>
              <v-spacer></v-spacer>
              <v-layout row justify-end>
                <v-flex xs12>
                  <v-text-field
                    v-model="search"
                    prepend-icon="search"
                    label="Tìm kiếm"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :rows-per-page-items="rowPerPage"
            >
              <template #headers="props">
                <tr>
                  <th
                    class="text-xs-center fw-bold"
                    v-for="header in props.headers"
                    :key="header.text"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template #items="props">
                <td class="text-center">{{ props.item.receipt_id }}</td>
                <td class="text-center">{{ props.item.room_id }}</td>
                <td class="text-center text-no-wrap">
                  {{ props.item.dateCreate }}
                </td>
                <td class="text-center text-no-wrap">
                  {{ props.item.explain }}
                </td>
                <td class="text-center">{{ props.item.month_apply }}</td>
                <td class="text-center text-no-wrap">{{ props.item.name }}</td>
                <td class="text-center">{{ props.item.motorbike_number }}</td>
                <td class="text-center">{{ props.item.phone }}</td>
                <td class="text-center">{{ props.item.washing_machine }}</td>
                <td class="text-center">{{ props.item.internet_price }}</td>
                <td class="text-center text-no-wrap">
                  {{ props.item.dateIn }}
                </td>
                <td class="text-center text-no-wrap">
                  {{ props.item.dateInReal }}
                </td>
                <td class="text-center">{{ props.item.electric_count_1 }}</td>
                <td class="text-center">{{ props.item.water_count_1 }}</td>
                <td class="text-center">{{ props.item.roomPrice }}</td>
                <td class="text-center">{{ props.item.note }}</td>
                <td class="text-center">{{ props.item.information_id }}</td>
                <td class="text-center">{{ props.item.information_id }}</td>
                <td class="text-center">{{ props.item.information_id }}</td>
              </template>
            </v-data-table>
          </app-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: false,
      search: "",
      headers: [
        { text: "Chứng từ", align: "center", value: "receipt_id" },
        { text: "Số phòng", align: "center", value: "room_id" },
        { text: "Ngày tạo", align: "center", value: "dateCreate" },
        { text: "Diễn giải", align: "center", value: "explain" },
        { text: "Tháng áp dụng", align: "center", value: "month_apply" },
        { text: "Họ tên", align: "center", value: "name" },
        { text: "Biển số xe", align: "center", value: "motorbike_number" },
        { text: "SDT", align: "center", value: "phone" },
        { text: "Máy giặt", align: "center", value: "washing_machine" },
        { text: "Sử dụng mạng", align: "center", value: "internet_price" },
        { text: "Ngày nhận phòng", align: "center", value: "dateIn" },
        { text: "Ngày trả phòng", align: "center", value: "dateInReal" },
        { text: "Số điện", align: "center", value: "electric_count_1" },
        { text: "Số nước", align: "center", value: "water_count_1" },
        { text: "Số tiền trả phòng", align: "center", value: "room_price" },
        { text: "Giải thích", align: "center", value: "note" },
        { text: "Chứng từ", align: "center", value: "information_id" },
        { text: "Chứng từ", align: "center", value: "information_id" },
        { text: "Chứng từ", align: "center", value: "information_id" },
      ],
      items: [],
      loading: {
        submit: false,
      },
      rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
    };
  },
  mounted() {
    this.getTablesData();
  },
  methods: {
    getTablesData() {
      let dummy_data = [
        {
          receipt_id: "105-TT",
          dateCreate: "3/6/2018",
          room_id: "519GB",
          explain: "Thêm người",
          month_apply: "Tháng 8",
          name: "Nguyễn Thị Thoại Thương",
          motorbike_number: "49H1-13371",
          phone: "0902874321",
          dateIn: "31/03/2019",
          dateInReal: "31/03/2019",
          note: "",
          internet_price: "209,000",
          electric_count_1: "749",
          electric_count_2: "749",
          water_count_1: "81",
          water_count_2: "81",
          electric_diff: "0",
          water_diff: "0",
          is_contracted: "có",
          information_id: "19-DC",
          room_price: "2,700,000",
          washing_machine: "Có",
        },
      ];
      for (let index = 0; index < 7; index++) {
        const element = dummy_data[0];
        this.items.push(element);
      }
    },
  },
};
</script>
